import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DOCUMENT,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { Params } from '@angular/router';
import { CarouselComponent, CarouselService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AimoCMSBannerComponent } from '../../../model/cms.model';
import { AimoGtmService } from '../../../service/gtm/aimo-gtm.service';
import { AimoProductService } from '../../../service/product/aimo-product.service';
import { AimoGtmStoredParams } from '../../../model/cart.model';

import { AimoProduct } from '../../../model/product.model';

@Component({
    selector: 'aimo-cx-carousel',
    templateUrl: './aimo-carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AimoCarouselComponent extends CarouselComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() slideChange = new EventEmitter<number>();
    @Output() scrollChange = new EventEmitter<number>();

    @Input() banner$: Observable<AimoCMSBannerComponent>;
    @Input() banners: AimoCMSBannerComponent[];
    @Input() showAllText: string;
    @Input() showAllUrl: string;
    @Input() idSuffix: string;
    @Input() gtmParams: AimoGtmStoredParams;
    @Input() showAsAccordion: boolean = false;

    accordionOpen: boolean;

    gtmScrollActive = true;
    gtmTriggeredItems: AimoProduct[] = [];
    @ViewChild('divSlides', { static: false })
    carouselWrapper: ElementRef<HTMLDivElement>;
    @ViewChild('divContainer', { static: false })
    divContainer: ElementRef<HTMLDivElement>;

    constructor(
        protected el: ElementRef,
        protected carouselService: CarouselService,
        protected productService: AimoProductService,
        protected gtmService: AimoGtmService,
        protected cdr: ChangeDetectorRef,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        super(el, carouselService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.accordionOpen = true;
    }

    ngAfterViewInit(): void {
        this.tryToTriggerGtmEvent();
        if (this.divContainer) {
            this.divContainer.nativeElement.scrollLeft = 0;
        }
    }

    @HostListener('window:scroll', [])
    isScrolledIntoView() {
        this.tryToTriggerGtmEvent();
    }

    private tryToTriggerGtmEvent(): void {
        if (this.gtmParams && this.items && this.gtmScrollActive) {
            this.triggerGtmEvent(this.items);
        }
    }

    private triggerGtmEvent(slides: Observable<AimoProduct>[]): void {
        AimoGtmService.triggerInViewEvent(this.document, this.carouselWrapper, false, () => {
            const products: AimoProduct[] = [];
            slides.forEach((item) => {
                item.subscribe((i) => {
                    const id = 'slide_' + i.code + '_' + this.idSuffix;
                    if (
                        AimoGtmService.isInView(this.document.getElementById(id), this.document, true) &&
                        this.gtmTriggeredItems.find((pi) => i.code === pi.code) === undefined
                    ) {
                        products.push(i);
                    }
                }).unsubscribe();
            });
            if (products.length > 0) {
                this.gtmTriggeredItems.push(...products);
                this.productService.fireProductListViewGtmEvent(products, undefined, undefined, this.gtmParams);
            }
        });
        if (this.gtmTriggeredItems.length >= slides.length) {
            this.gtmScrollActive = false;
        }
    }

    scrollContainer(divContainer: HTMLElement, isPrevious: boolean): void {
        if (isPrevious) {
            divContainer.scrollLeft -= divContainer.offsetWidth;
            this.slideChange.emit(-divContainer.offsetWidth);
        } else {
            divContainer.scrollLeft += divContainer.offsetWidth;
            this.slideChange.emit(divContainer.offsetWidth);
        }
        setTimeout(() => {
            const e = new Event('scroll', {
                bubbles: true,
                cancelable: false,
            });
            this.document.defaultView.window.dispatchEvent(e);
        }, 1000);
    }

    showButton(divContainer: HTMLElement, isPrevious = false, divSlides?: HTMLElement): boolean {
        if (isPrevious) {
            return divContainer.scrollLeft > 0;
        } else {
            return divContainer.scrollLeft + divContainer.offsetWidth < divSlides.offsetWidth;
        }
    }

    showScroll(): boolean {
        return this.carouselWrapper?.nativeElement?.offsetWidth > this.divContainer?.nativeElement?.offsetWidth;
    }

    scroll(divContainer: HTMLElement): void {
        this.scrollChange.emit(divContainer.scrollLeft);
        this.tryToTriggerGtmEvent();
    }

    ngOnDestroy(): void {}

    getInternalQueryParams(): Params {
        return {
            promotion_id: this.gtmParams.gtmPromotionId,
            promotion_name: this.gtmParams.gtmPromotionName,
            creative_slot: this.gtmParams.gtmCreativeSlot,
            item_list_id: this.gtmParams.gtmItemListId,
        };
    }

    toggleAccordion(): void {
        this.accordionOpen = !this.accordionOpen;
    }
}
